import { render } from "./DiscoverGridSkeleton.vue?vue&type=template&id=e320af8c&scoped=true"
import script from "./DiscoverGridSkeleton.vue?vue&type=script&lang=js"
export * from "./DiscoverGridSkeleton.vue?vue&type=script&lang=js"

import "./DiscoverGridSkeleton.vue?vue&type=style&index=0&id=e320af8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e320af8c"]])

export default __exports__